import { useEffect } from 'react';

const useSetupFlow = ({
  needsInitialChannel,
  pendingCheckout,
  currentPath,
  navigate,
  hasActiveSubscription,
}) => {
  useEffect(() => {
    if (hasActiveSubscription === false) {
      return;
    }
    if (needsInitialChannel && !pendingCheckout && currentPath !== '/setup/channel') {
      navigate('/setup/channel', { replace: true });
    }
  }, [needsInitialChannel, pendingCheckout, currentPath, hasActiveSubscription, navigate]);
};

export default useSetupFlow;
